import React from 'react';
import {toast} from 'react-toastify';
import InApp from 'detect-inapp';
import CryptoJS from "crypto-js";
import moment from "moment";
import {addDays, addMonths, differenceInCalendarDays, endOfDay, endOfMonth, endOfWeek, isSameDay, startOfDay, startOfMonth, startOfWeek,startOfYear,endOfYear,addYears} from 'date-fns';
import * as Icon from 'ubs-icons';
import {COLOR, CONSTANT, FORMAT, LIMIT, LOGIN_METHOD, REGEX, CURRENCY_LOCALE} from './constant';
import {checkDate} from "./convert";
import {dateFormatter} from "./date";

/**====================================================
 *  V2 Final functions
 *====================================================*/
export const Decryption = (data) => {
    try {
        return process.env.REACT_APP_ENC_KEY ? JSON.parse(CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENC_KEY).toString(CryptoJS.enc.Utf8)) : data;
    } catch {
        return false;
    }
};
export const Encryption = (data) => process.env.REACT_APP_ENC_KEY ? CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_ENC_KEY).toString() : data;
export const DoubleEncryption = (data) => Encryption(btoa(Encryption(data)));
export const DoubleDecryption = (data) => Decryption(atob(Decryption(data)));
export const setLocal = (key, value) => localStorage.setItem(key, Encryption(value));
export const getLocal = (key) => Decryption(localStorage.getItem(key));
export const copyStatusReport = (data = []) => {
    const values = data.map(e => ` - ${e?.task?.link || e?.task?.name} - ${e?.activityType?.name || ''} - ${secondsToHm(e?.duration, true)}<br/>`).join('');
    const formatID = document.getElementById("u_copy-text") || document.getElementById("u_status-report");
    if (formatID) formatID.innerHTML = values;
    copyToClipboard(formatID?.innerText);
    showToastSuccess('Status Report Copied Successfully!');
};
export const copyToClipboard = (url) => {
    const el = document.createElement('textarea');
    el.value = url;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
};
export const copyTicketLink = (ticketId) => {
    const ticketURL = ticketId ? `${window.location.href}/${ticketId}` : window.location.href;
    navigator.clipboard.writeText(ticketURL);
    showToastSuccess('Ticket link copied to clipboard.');
};
export const getThumbor = (dimension = '48x48', quality = 80) => {
    if (process.env.REACT_APP_THUMBOR_URL) return `${process.env.REACT_APP_THUMBOR_URL}/${dimension}/filters:quality(${quality})/`
    else return ''
}


/**====================================================
 *  Old functions
 *====================================================*/
export const dateToString = (date, withTime) => {
    return moment(date ? new Date(date) : new Date()).format(withTime ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY')
}
export const stringToDate = (string, withTime) => {
    return new Date(moment(string, withTime ? 'YYYY-MM-DD HH:mm:ss' : 'YYYY-MM-DD')).getTime()
}

const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -6)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -6)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
    startOfCurrentYear: startOfYear(new Date()),
    endOfCurrentYear: endOfYear(new Date()),
    startOfNextYear: startOfYear(addYears(new Date(), 1)),
    endOfNextYear: endOfYear(addYears(new Date(), 1)),
    startOfLastYear: startOfYear(addYears(new Date(), -1)),
    endOfLastYear: endOfYear(addYears(new Date(), -1))
};
const staticRangeHandler = {
    range: {},
    isSelected(range) {
        const definedRange = this.range();
        return (
            isSameDay(range.startDate, definedRange.startDate) &&
            isSameDay(range.endDate, definedRange.endDate)
        );
    },
};


export const isElectron = () =>
    (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') ||
    (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) ||
    (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0)

export const detectDevice = (isName = false) => {
    const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
    if (isElectron()) return isName ? 'DESKTOP' : LOGIN_METHOD.DESKTOP;
    else if (('ontouchstart' in document.documentElement) || (inapp.isMobile && inapp.isInApp)) return isName ? 'MOBILE' : LOGIN_METHOD.MOBILE;
    else return isName ? 'WEB' : LOGIN_METHOD.WEB;
}

export const bottomTouch = (e, gap = 0) => {
    return Math.ceil(e.target.scrollTop) + Math.ceil(e.target.clientHeight) >= Math.ceil(e.target.scrollHeight) - (Math.ceil(e.target.clientHeight) * gap)
}

// for add 3 dots in string
export const add3Dots = (source, size) => {
    return (source && source.length > size) ? source.slice(0, size - 1) + "…" : source;
}

// Hex to RGB
export const hexToRgba = (hex, alpha) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    const bg_color = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
    if (bg_color) return `rgba(${bg_color.r}, ${bg_color.g}, ${bg_color.b}, ${alpha ? alpha : 1})`;
    return ''
}

export const findArray = (arrList = [], id) => {
    if (arrList && arrList.length) return arrList.find(_ => _.value === id)
}

export const isMobileDevice = () => {
    return ('ontouchstart' in document.documentElement);
}

export const errorFocus = (flag) => {
    setTimeout(() => {
        const elem = document.getElementsByClassName('u_input-error')
        if (elem && elem[0]) {

            if (flag === 'top') elem[0].scrollIntoView({behavior: "smooth"});
            else elem[0].scrollIntoView({behavior: "smooth", block: "nearest", inline: 'nearest'});
        }
    }, 200)
}

export const dataURLtoFile = (dataUrl, filename, mime = "image/jpg") => {
    let arr = dataUrl.split(','),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {type: mime});
}

export const isIpadOS = () => {
    return navigator.maxTouchPoints &&
        navigator.maxTouchPoints > 2 &&
        /MacIntel/.test(navigator.platform);
}
export const isInApp = () => {
    const inapp = new InApp(navigator.userAgent || navigator.vendor || window.opera);
    const inIpadOs = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
    if (inIpadOs && navigator.userAgent.includes('Safari')) return false
    else if (inapp.isInApp || inIpadOs) return true
    else return inapp.isInApp
}

export const isMobileTablet = () => {
    let check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)))
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export const getMobileOperatingSystem = () => {
    let userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}

export const isThisAFile = (maybeFile) => {
    return new Promise(function (resolve, reject) {
        if (maybeFile.type !== '') {
            return resolve(maybeFile);
        }
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.error && reader.error.name === 'NotFoundError') {
                return reject(reader.error.name);
            }
            resolve(maybeFile);
        };
        reader.readAsBinaryString(maybeFile);
    });
};

export const checkAttachment = (url) => {
    /** check attachment type */
    if (url) {
        const name = url.split('.');
        const ext = name[name.length - 1];
        return ext;
    }
}

export const fixed = (value, count = 0) => {
    return (Number(value) || 0).toFixed(count)
}


export const isInViewport = (element, ref) => {
    return (
        element.getBoundingClientRect().top >= 0 &&
        element.getBoundingClientRect().bottom <= (ref.innerHeight || document.documentElement.clientHeight)
    );
}

export const getName = (user) => {
    return user?.name || `${user ? user?.firstName : '-'} ${user ? user?.lastName : '-'}`
}

export function timeToMoment12Hours(value) {
    if (value) {
        let date = moment();
        let time = moment(value, ["h:mm A"]).format("HH:mm");
        let splitTime = time.split(':');
        if (splitTime?.length > 1) return date.set('hour', splitTime[0]).set('minute', splitTime[1]);
        else return null;
    } else return ''
}


export function getDiffrenceInMinute(start, end) {
    if (start && end && ![typeof start, typeof end]?.includes('number')) {
        start = start?.split(":");
        end = end?.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    } else {
        if (start && end) {
            return minutesToHm(end - start, true, true)
        }
    }
}

export const getTimeDifference = (start, end) => {
    if (start && end) {
        start = start.split(":");
        end = end.split(":");
        let startDate = new Date(0, 0, 0, start[0], start[1], 0);
        let endDate = new Date(0, 0, 0, end[0], end[1], 0);
        let diff = endDate.getTime() - startDate.getTime();
        //if(diff < 0) diff = Math.abs(diff)
        let hours = Math.floor(diff / 1000 / 60 / 60);
        let tempHr = Math.floor(diff / 1000 / 60 / 60);
        if (hours < 0) hours += 24
        diff -= tempHr * 1000 * 60 * 60;
        let minutes = Math.floor(diff / 1000 / 60);
        if (minutes < 0) minutes = Math.abs(minutes)
        return (hours <= 9 ? "0" : "") + hours + ' Hrs ' + " " + (minutes <= 9 ? "0" : "") + minutes + ' Mins';
    }
}
export const secondsToHms = (d, flag) => {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (s < 10) s = '0' + s;
    if (flag) return `${h} H : ${m} M : ${s} S`;
    else return `${h}:${m}:${s}`;
}
export const secondsToHm = (d, flag) => {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (flag) return `${h} H : ${m} M`;
    else return `${h}:${m}`;
}
export const checkPlusDay = (d1, date) => {
    d1 = moment(d1).set({hour: 0, minute: 0, second: 0})
    if (d1 && d1?.diff(date, 'day') > 0) return true;
    else return false;
}
export const getDate = (date, flag = 'start') => {
    const day = (date || date?.length !== 0) ? new Date(date) : new Date()
    return day.setHours(flag === 'start' ? 0 : 23, flag === 'start' ? 0 : 59, flag === 'start' ? 0 : 59, flag === 'start' ? 0 : 999);
}
export const timeDiff = (d1, d2) => {
    d1 = moment(d1);
    d2 = moment(d2);
    if (d1?.isSameOrBefore(d2)) return 1;
    else if (d1?.isSameOrBefore(moment())) {
        let duration = moment.duration(d1?.diff(d2));
        let hours = parseInt(duration.asHours());
        let minutes = parseInt(duration.asMinutes()) % 60;
        if (hours >= 0 && hours < 10) hours = "0" + hours;
        if (minutes >= 0 && minutes < 10) minutes = "0" + minutes;
        if (hours >= 0 || minutes >= 0) return `${hours} H : ${minutes} M`;
        else if (hours < 0 || minutes < 0) return 1;
    } else return 2;
};
export const numberWithComaToFixed = (n, code, removeZero = false, locale = 'en-IN') => {
    const num = Number(n);
    if (isNaN(num)) return '';

    // Check if the number has decimals
    const hasDecimals = num % 1 !== 0;

    if (code) {
        return num?.toLocaleString(CURRENCY_LOCALE[code]?.language || 'en-IN',
            {
                style: 'currency',
                currency: code,
                minimumFractionDigits: (removeZero && !hasDecimals) ? 0 : 2,
                maximumFractionDigits: (removeZero && !hasDecimals) ? 0 : 2
            });
    } else {
        return num?.toLocaleString(CURRENCY_LOCALE[code]?.language || 'en-IN')
    }
}

export const getKeyValue = (arrName = [], key = 'name') => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e._id] = e[key]
    })
    return finalObject
}
export const getFiltersLen = (filters) => {
    return filters && Object.values(filters)?.filter(x => x !== null && x !== '' && x !== undefined && x?.length !== 0)?.length;
}

export function createStaticRanges(ranges) {
    return ranges.map(range => ({...staticRangeHandler, ...range}));
}

export const defaultStaticRanges = createStaticRanges([
    {
        label: 'Today',
        range: () => ({
            startDate: defineds.startOfToday,
            endDate: defineds.endOfToday,
        }),
    },
    {
        label: 'Yesterday',
        range: () => ({
            startDate: defineds.startOfYesterday,
            endDate: defineds.endOfYesterday,
        }),
    },
    {
        label: 'Last Week',
        range: () => ({
            startDate: defineds.startOfLastWeek,
            endDate: defineds.endOfLastWeek,
        }),
    },
    {
        label: 'Last Month',
        range: () => ({
            startDate: defineds.startOfLastMonth,
            endDate: defineds.endOfLastMonth,
        }),
    },
    {
        label: 'Current Year',
        range: () => {
            return {
                startDate: defineds.startOfCurrentYear,
                endDate: defineds.endOfCurrentYear,
            }
        },
        rangeType: true
    },
    {
        label: 'Last Year',
        range: () => {
            return {
                startDate: defineds.startOfLastYear,
                endDate: defineds.endOfLastYear,
            }
        },
        rangeType:true
    },
    {
        label: 'Next Year',
        range: () => {
            return {
                startDate: defineds.startOfNextYear,
                endDate: defineds.endOfNextYear,
            }
        },
        rangeType: true
    },
]);
export const defaultInputRanges = [
    {
        label: 'days up to today',
        range(value) {
            return {
                startDate: addDays(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
                endDate: defineds.endOfToday,
            };
        },
        getCurrentValue(range) {
            if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
            if (!range.startDate) return '∞';
            return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
        },
    }
];
export const showFilterDateRange = (date, filterName = 'Date') => {
    let filterStartDate = date[0]?.startDate ? moment(date[0]?.startDate).format('D MMM YY') : `Select ${filterName}`;
    let filterEndDate = date[0]?.endDate ? moment(date[0]?.endDate).format('D MMM YY') : `Select ${filterName}`;

    filterEndDate = filterStartDate === filterEndDate ? '' : ` - ${filterEndDate}`;

    return date.length !== 0 ? `${filterName}: ${filterStartDate}${filterEndDate}` : `${filterName}`;
}
export const getKeyName = (arrList = [], id) => {
    if (arrList && arrList?.length) return arrList?.find(_ => _.value == id)
}
export const setDate = (date, format) => {
    if (!date) return '';
    if (date.length === 0) return '';
    return moment(date).format(format);
};
export const getTimeStamp = () => ~~(Date.now() / 1000);
export const getDifference = (timestamp) => getTimeStamp() - timestamp;
export const convertTime = (secs = 0, format) => {
    const digit = d => d.toString().length === 1 ? `0${d}` : d;

    const h = digit(Math.floor(secs / (60 * 60)));

    const divisor_for_minutes = secs % (60 * 60);
    const m = digit(Math.floor(divisor_for_minutes / 60));

    const s = digit(Math.ceil(divisor_for_minutes % 60));

    if (format === 'hms') {
        if (h !== '00') return `${h}h ${m}m ${s}s`;
        else if (m !== '00') return `00h ${m}m ${s}s`;
        else return `00h 00m ${s}s`;
    } else if (format === 'h:m:s') {
        if (h !== '00') return `${h}:${m}:${s}`;
        else if (m !== '00') return `00:${m}:${s}`;
        else return `00:00:${s}`;
    } else if (format === 'h.m') {
        return (secs / 60 / 60).toFixed(2)
    } else {
        if (h !== '00') return `${h}h ${m}m`;
        else if (m !== '00') return `00h ${m}m`;
        else return `00h 00m`;
    }
}
export const convertTimeNumberToString = (sec) => {
    let hours = Math.floor(sec / 3600);
    (hours >= 1) ? sec = sec - (hours * 3600) : hours = '00';
    hours = hours > 9 ? "" + hours : "0" + hours;
    let min = Math.floor(sec / 60);
    (min >= 1) ? sec = sec - (min * 60) : min = '00';
    (sec < 1) ? sec = '00' : void 0;

    (min.toString().length === 1) ? min = '0' + min : void 0;
    return hours + ':' + min;
}
export const getSplitTime = (time) => {
    const converTime = convertTimeNumberToString(time)
    if (!converTime) return '00h 00m'
    const split = converTime.split(':')
    if (split.length === 2 && split[0] === "") return `00h ${split[1]}m`;
    else if (split.length === 2 && split[1] === "") return `${split[0]}h 00m`;
    else return `${split[0]}h ${split[1]}m`
}
export const loadOptions = (input, cb, list) => {
    const result = list.filter(i =>
        i.label.toLowerCase().includes(input.toLowerCase())
    );
    cb(result.slice(0, 10))
}
export const showToastSuccess = (msg) => {
    toast(
        <div className="u_toast-inner u_toast-inner-success">
            <div className="u_flex u_align-center u_content-center">
                <Icon.Checked fill={COLOR.u_green} size={18}/>
                <div className="u_pl-5">
                    <p>{msg}</p>
                </div>
            </div>
        </div>
        , {
            className: 'u_toast',
            position: 'top-center',
            autoClose: LIMIT.TOAST_TIME_OUT,
            hideProgressBar: true,
            closeButton: false,
        });
}
export const showToastError = (msg) => {
    toast(
        <div className="u_toast_wrong-inner u_toast_wrong-inner-success">
            <div className="u_flex u_align-center">
                <Icon.Warning size={18} fill={COLOR.u_red}/>
                <div className="u_pl-5">
                    <p>{msg}</p>
                </div>
            </div>
        </div>,
        {
            className: "u_toast_wrong",
            position: "top-center",
            autoClose: LIMIT.TOAST_TIME_OUT,
            hideProgressBar: true,
            closeButton: false,
        }
    );
};
// for admin and chat project toastMessage
export const notificationToast = (type, title, message) => {
    toast(
        <div className={`u_toast-inner u_toast-inner-${type}`}>
            <div className="u_flex u_align-center u_content-center">
                {type === 'success' && <Icon.Checked size={18} fill={COLOR.u_green}/>}
                {type === 'warning' && <Icon.Warning size={18} fill={COLOR.u_red}/>}
                {type === 'error' && <Icon.QuestionMark size={18} fill={COLOR.u_red}/>}
                <div className="u_pl-5">
                    <p>{message}</p>
                </div>
            </div>
        </div>
        , {
            className: `${type === 'warning' || type === 'error' ? 'u_toast_wrong' : 'u_toast' }`,
            position: 'top-center',
            autoClose: LIMIT.TOAST_TIME_OUT,
            hideProgressBar: true,
            closeButton: false
        });
};

export const copyTaskLink = (link) => {
    navigator.clipboard.writeText(link);
    showToastSuccess("Link copied to clipboard.")
};

export const copyLink = (link, text) => {
    navigator.clipboard.writeText(link);
    showToastSuccess(`${text} link copied to clipboard.`);
};
export const compareFilterDates = (date, newDate) => {
    let filteredDates = JSON.parse(date);
    let isMatch = dateFormatter({date: filteredDates?.[0]?.startDate, format: 'DD/MM/YYYY'
}) === dateFormatter({date: newDate?.[0]?.startDate, format: 'DD/MM/YYYY'
}) && dateFormatter({date: filteredDates?.[0]?.endDate, format: 'DD/MM/YYYY'
}) === dateFormatter({date: newDate?.[0]?.endDate, format: 'DD/MM/YYYY'
});
    return isMatch ? '' : 1;
}
export const removeByAttr = (arr, attr, value) => {
    let i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {
            arr.splice(i, 1);

        }
    }
    return arr;
}
export const random = {
    id: (length = 16) => (Math.floor(Math.pow(10, length - 1) + Math.random() * (Math.pow(10, length) - Math.pow(10, length - 1) - 1))).toString(),
    color: () => CONSTANT.COLORS[Math.floor(Math.random() * CONSTANT.COLORS.length)],
    number: (min = 0, max = 100) => Math.floor(Math.random() * (max - min + 1) + min)
};
export const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return '0 Byte';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};
export const searchInArray = (str, array, key) => {
    // Escape special characters in the search string
    const escapedStr = str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(escapedStr?.toLowerCase());
    return array.filter(data => {
        if (key) return !!data[key]?.toLowerCase()?.match(pattern);
        else return !!data?.toLowerCase()?.match(pattern);
    });
};
export const getExtension = (url) => {
    return url?.split(/[#?]/)[0].split('.')?.pop()?.trim() || '-';
}
export const dayPipe = (date, flag) => {
    const DATE = moment(date);
    const REFERENCE = moment();
    const TODAY = REFERENCE.clone().startOf('day');
    const YESTERDAY = REFERENCE.clone().subtract(1, 'days').startOf('day');
    if (flag === 'comment') {
        if (DATE.isSame(REFERENCE, 'week')) {
            // Check if date is today, yesterday, weekday or others
            const m = parseInt(moment.duration(REFERENCE.diff(DATE)).asMinutes());
            if (m < 2) return `Just now`;
            else if (m < 60) return `${m} minutes ago`;
            else if (DATE.isSame(TODAY, 'd')) return `Today ${DATE.format(FORMAT.TIME)}`;
            else if (DATE.isSame(YESTERDAY, 'd')) return `Yesterday ${DATE.format(FORMAT.TIME)}`;
            else return DATE.format(FORMAT.DAY_TIME);
        } else return DATE.format(FORMAT.DATE_TIME);
    } else if (flag === 'time') {
        // If you want only time from date object
        return DATE.format(FORMAT.TIME);

    } else if (flag === 'date') {

        // If you want only date from date object
        if (DATE.isSame(REFERENCE, 'week')) {

            // Check if date is today, yesterday, weekday or others
            if (DATE.isSame(TODAY, 'd')) return DATE.format(FORMAT.TIME);
            else if (DATE.isSame(YESTERDAY, 'd')) return 'Yesterday';
            else return DATE.format('dddd');

        } else return DATE.format(FORMAT.DATE);
    } else {

        // If you want only date and time both from date object
        if (DATE.isSame(REFERENCE, 'week')) {

            // Check if date is today, yesterday, weekday or others
            if (DATE.isSame(TODAY, 'd')) return `Today ${DATE.format(FORMAT.TIME)}`;
            else if (DATE.isSame(YESTERDAY, 'd')) return `Yesterday ${DATE.format(FORMAT.TIME)}`;
            else return DATE.format(FORMAT.DAY_TIME);

        } else return DATE.format(FORMAT.DATE_TIME);
    }
};

/** insert data in array at specific index  */
const insertAt = (array, index, ...elementsArray) => {
    return array.splice(index, 0, ...elementsArray);
}

export function checkMinLength(value, length) {
    return value && value.length >= length
}

export function checkUppercase(value) {
    return (REGEX.upperCase.test(value));
}

export function checkLowercase(value) {
    if (value) return (REGEX.lowerCase.test(value));
    else return false
}

export function checkNumeric(value) {
    return REGEX.number.test(value)
}

export function checkSpecialCharacter(value) {
    return REGEX.specialChar.test(value)
}

export const getDateList = (s, e) => {
    for (var a = [], d = new Date(s); d <= new Date(e); d.setDate(d.getDate() + 1)) {
        a.push(moment(new Date(d)).format(FORMAT.DATE));
    }
    return a;
}
export const getUTC = (date = new Date(), flag) => {
    const convertedDate = moment.utc(date)
    if (flag === 'start') convertedDate.startOf('day')
    if (flag === 'end') convertedDate.endOf('day')
    return moment.utc(convertedDate).format()
}
export const toISOIgnoreTimezone = (inputDate) => {
    return inputDate.getFullYear() + "-" +
        ("0" + (inputDate.getMonth() + 1)).slice(-2) + "-" +
        ("0" + inputDate.getDate()).slice(-2) + "T00:00:00.000Z";
}
export const utcDueDate = (date) => moment(date).format(FORMAT.TIME) !== '12:00 AM' ? getUTC(date) : toISOIgnoreTimezone(date)
export const getDateTime = (selectedDate, withTime = false) => {
    if (!selectedDate) return ''
    const dateString = checkDate(selectedDate)
    const date = moment.utc(selectedDate).format(withTime ? FORMAT.DATE : FORMAT.DUE_DATE)
    const time = moment(selectedDate).format(FORMAT.TIME)
    const showTime = moment.utc(selectedDate).format(FORMAT.TIME)
    const show = withTime && showTime !== '12:00 AM'

    if (dateString === 'Today' || dateString === 'Yesterday' || dateString === 'Tomorrow') return show ? `${dateString} ${time}` : dateString
    else if (dateString === 'Older' || dateString === 'Upcoming' || dateString === 'This Month' || dateString === 'This Week' || dateString === 'No Due Date') return show ? `${date} ${time}` : date
    else return ''
}
export const parseDateTime = {
    dueDate: (date) => date ? new Date(date) : date,
    dueTime: (date) => {
        const showTime = moment.utc(date ? new Date(date) : date).format(FORMAT.TIME)
        return showTime !== '12:00 AM' ? (date ? moment(date) : date) : null
    }
}
/** detect webcam */
export const isWebcamEnabled = () => {
    return new Promise(function (resolve, reject) {
        // Check for browser support
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
            reject(new Error('Browser does not support mediaDevices API'));
        }

        // Enumerate devices
        navigator.mediaDevices.enumerateDevices()
            .then(function (devices) {
                // Check for video input devices
                const videoDevices = devices.filter(function (device) {
                    return device.kind === 'videoinput';
                });

                resolve(videoDevices.length > 0);
            })
            .catch(function (error) {
                reject(error);
            });
    });
}

/** Webcam permission */
export const isWebcamPermissionDenied = () => {
    return new Promise(function (resolve, reject) {
        navigator.mediaDevices.getUserMedia({video: true})
            .then(function (stream) {
                // Webcam permission granted
                stream.getTracks().forEach(function (track) {
                    track.stop();
                });
                resolve(false);
            })
            .catch(function (error) {
                if (error.name === 'NotAllowedError') {
                    // Webcam permission denied
                    resolve(true);
                } else {
                    // Other errors
                    reject(error);
                }
            });
    });
}

export function minutesToNumberString(value, isHM) {
    if (value <= 1440) {
        let hour = Math.floor(parseFloat(Math.abs(value)) / 60)?.toString()?.padStart(2, '0') || "00";
        let minute = Math.round(parseFloat(Math.abs(value)) % 60)?.toString()?.padStart(2, '0') || "00";
        if (isHM) return `${hour}H:${minute}M`
        return hour + ":" + minute || "00:00";
    } else return "00:00"
}

export function hourToMinute(value) {
    /**
     * value must be in HH:MM
     * */
    if (value && typeof value === 'string') return Math.floor(Number(value?.split(":")[0]) * 60 + Number(value?.split(":")[1]));
    else if (typeof value === "number") return minutesToNumberString(value)
    else return 0
}

export function stringToTime(value, format = "HH:mm") {
    if (value) {
        let date = new Date();
        let time = moment(value, [format]).format("HH:mm");
        let splitTime = time.split(':');
        date.setHours(splitTime[0])
        date.setMinutes(splitTime[1])
        date.setSeconds(0)
        date.setMilliseconds(0)
        if (splitTime?.length > 1) return date;
        else return null;
    } else return ''
}

export const minutesToHm = (d, flag, isHrs = false) => {
    let isNegative = (Math.sign(d) === -1) ? true : false;
    if (d < 0) d = d * -1
    d = Number(d);
    let h = Math.floor(d / 60);
    /** need precision in minutes but not in hours so round method selected if we select floor it will loose 1 minute.*/
    let m = Math.round(d % 60);
    if (h < 10) h = '0' + h;
    if (m < 10) m = '0' + m;
    if (flag && isNegative) {return `-${h} Hrs : ${m} Mins`}
    if(isHrs){return `${h} Hrs : ${m} Mins`}
    if (flag && isNegative) {return `-${h}H : ${m}M`}
    else if(flag){return `${h}H : ${m}M`}
    else return `${h}:${m}`;
}

export function minutesTo12Hour(minutes = 0) {
    return timeToMoment12Hours(minutesToHm(minutes)).format('h:mm A') || "12:00AM"
}

export const clearValidation = (validator = {}, keys = [], allClear = false) => {
    if (validator.current && validator.current.fields && keys?.length) {
        keys?.forEach(_ => {
            validator.current.hideMessageFor(_);
            delete validator.current.errorMessages[_];
            validator.current.fields[_] = true;
        });
        validator.current.hideMessages();
    }
    if (allClear) {
        // For clear All validation,  No need To pass keys one by one
        const keys = Object?.keys(validator.current.fields)
        if (keys?.length) {
            keys?.forEach(_ => {
                validator.current.hideMessageFor(_);
                delete validator.current.errorMessages[_];
                validator.current.fields[_] = true;
            });
            validator.current.hideMessages();
        }
    }
}
export const mergeObjects = (obj1, obj2) => {
    for (let key in obj2) {
        // If obj1 has this key and both values are objects, merge them recursively
        if (obj1.hasOwnProperty(key)) {
            // If both values are objects, merge them recursively
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                mergeObjects(obj1[key], obj2[key]);
            } else {
                // Otherwise, overwrite the value in obj1 with the value from obj2
                obj1[key] = obj2[key];
            }
        }
    }
    return obj1; // Return the modified obj1
}

// This function capitalizes the first letter of a given string
export function capitalizeFirstLetter(val = "") {
    val = String(val)?.toLowerCase();
    return val?.charAt(0)?.toUpperCase() + val?.slice(1);
}

export const spiltContact = (num) => {
    if (num?.length > 0) {
        return num.split('-')
    } else return ''
}
export const joinContact = (code, number) => `${code}-${number}`